'use strict';

function c(e,t){let n;return function(...o){let i=this,u=o;typeof window<"u"&&(window.clearTimeout(n),n=window.setTimeout(()=>e.apply(i,u),t));}}var d=c;

exports.a = d;
